import $ from 'jquery'
import 'magnific-popup'
import openSurveyPopup from './44-thank-you-survey'

export default {
	init() {

		/**
		* Upsell Modal
		* */
		let thankYouUpsell = $('#thank-you-upsell-offer')
		let thankYouSurvey = $('#thank-you-survey')
		// When the bb2-mini survey is on the page it opens first and chains this survey
		// on close, so skip the auto-open here (same gate as the upsell modal above).
		let bbminiSurvey = $('#checkout-bbmini-popup-survey')

		if(thankYouUpsell.length == 0 && bbminiSurvey.length == 0 && thankYouSurvey.length > 0) {
			this.openSurveyPopup()
		}

	},

	openSurveyPopup() {
		let thankYouSurvey = $('#thank-you-survey')

		if (thankYouSurvey.length > 0) {
			$.magnificPopup.open({
				type: 'inline',
				items: {
					src: thankYouSurvey,
					type: 'inline'
				}
			})
		}
	}
}
